import React from 'react'
import Slider from '../components/Home/Slider'
const HomePage = () => {
    return (
        <Slider />
    )
}

export default HomePage